export default "__VITE_ASSET__Dt7mlDqc__"